import React, { JSX } from 'react'

const CartIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill={props.fill || '#fff'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10886_15062)">
      <path
        d="M8.09977 1C9.26977 1 10.2498 1.87 10.4098 3H5.78977C5.94977 1.87 6.91977 1 8.09977 1ZM8.09977 0C6.25977 0 4.75977 1.49 4.75977 3.33V4H11.4298V3.33C11.4298 1.49 9.93977 0 8.09977 0Z"
        fill={props.fill || '#fff'}
      />
      <path
        d="M13.7943 4L14.7657 15H1.23429L2.20571 4H13.7943ZM14.8571 3H1.14286L0 16H16L14.8571 3Z"
        fill={props.fill || '#fff'}
      />
    </g>
    <defs>
      <clipPath id="clip0_10886_15062">
        <rect width="16" height="16" fill={props.fill || '#fff'} />
      </clipPath>
    </defs>
  </svg>
)

export default CartIcon
